import { useState,useEffect } from "react";
import { getNames } from "country-list";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const UniversityForm = () => {
 const navigate=useNavigate()
 const countryOptions = getNames().map((name) => ({
  label: name, 
  value: name, 
}));
  // console.log("Country Codes:",countries)
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [universityName,setUniversityName]=useState("")
  const [contactDetail,setContactDetail]=useState("")
  // const [pointOfContact,setPointOfContact]=useState("")
  const [choice, setChoice] = useState("select");

  const [logo,setLogo]=useState("")
  const [address,setAddress]=useState("")
  const [registrationNumber,setRegistrationNumber]=useState("")
  const [govDocuments,setGovDocuments]=useState("")
  const [universities, setUniversities] = useState([]);
  const [loading,setLoading]=useState(false)
  

   useEffect(() => {
  const fetchUniversities = async () => {
    try {
      const res = await fetch(
        `http://universities.hipolabs.com/search?country=${selectedCountry.label.replace(/[\s\u00A0]*\(.*?\)[\s\u00A0]*/g, "").trim()}`
      );
      // console.log("The response is:",res)
      const data = await res.json();
      setUniversities(data);
    } catch (error) {
      console.error(error);
    } 
  };

  if (selectedCountry) {
    fetchUniversities();
  }
}, [selectedCountry]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!universityName || !address || !contactDetail || !logo || !registrationNumber || !govDocuments){
      alert('all fields required')
      return;
    }
    const formData = new FormData();
    formData.append("university_name",universityName)
    formData.append("address",address)
    formData.append("contact",contactDetail)
    formData.append("registration_number",registrationNumber)
    formData.append("university_logo",logo)
    formData.append("documents",govDocuments)
    try {
      setLoading(true)
     const response = await fetch(`${BASE_URL}/marketplace/university/create-university-profile/`, {
  method: 'POST',
  headers: {
    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    // "Content-Type": "multipart/form-data",
    "x-api-key": process.env.REACT_APP_X_API_KEY,
  },
  body: formData,
});

      if (response.ok) {
        console.log('Registration successful!');
        alert("University Profile Created Successfully")
        resetForm();
      } else {
        console.error('Registration failed');
      }
      // alert("Registration submitted successfully!");
      navigate('/marketplace/university')
      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please try again.");
    } finally{
      setLoading(false)
    }
  };

  const resetForm = () => {
    setUniversityName("")
    setContactDetail("")
    // setPointOfContact("")
    setLogo("")
    setAddress("")
    setRegistrationNumber("")
    setGovDocuments("")
  };


  return (
//     <div className="text-start max-w-4xl mx-auto mt-10 p-8 bg-gradient-to-br from-white to-gray-50 shadow-xl rounded-2xl border border-gray-100">
//       <div className="mb-8">
//         <h2 className="text-3xl font-bold text-gray-800">University Registration</h2>
//       </div>

//       <form onSubmit={handleSubmit} className="space-y-8">
//         {/* Basic Information Section */}
//         <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          
//             {/* Name */}
// <div className="w-full mb-4">
//   <label className="block text-sm font-semibold text-gray-700 mb-2">
//     University <span className="text-red-500">*</span>
//   </label>

//   <div className="flex gap-4 items-end">
//     {/* Show selects if choice is select */}
//     {choice !== "manual" && (
//       <>
//         {/* Country Select */}
//         <div className="flex-1">
//           <Select
//             options={countryOptions}
//             isSearchable
//             value={selectedCountry}
//             onChange={(selected) => {
//               setSelectedCountry(selected);
//               setUniversityName(""); // reset university when country changes
//             }}
//             placeholder="Select country..."
//             styles={{
//               container: (base) => ({ ...base, width: "100%" }),
//               control: (base, state) => ({
//                 ...base,
//                 width: "100%",
//                 minHeight: "50px",
//                 padding: "0 8px",
//                 borderRadius: "0.75rem",
//                 borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
//                 boxShadow: state.isFocused
//                   ? "0 0 0 2px rgba(59,130,246,0.3)"
//                   : "none",
//                 "&:hover": { borderColor: "#3b82f6" },
//               }),
//               valueContainer: (base) => ({ ...base, padding: "0" }),
//               input: (base) => ({ ...base, margin: 0, padding: 0 }),
//             }}
//           />
//         </div>

//         {/* University Select */}
//         <div
//           className="flex-1"
//           onClick={() => {
//             if (!selectedCountry) alert("Please select country first");
//           }}
//         >
//           <Select
//             options={universities}
//             isSearchable
//             isDisabled={!selectedCountry}
//             getOptionLabel={(option) => option.name}
//             getOptionValue={(option) => option.name}
//             value={universities.find((u) => u.name === universityName) || null}
//             onChange={(selected) =>
//               setUniversityName(selected?.name || "")
//             }
//             placeholder={
//               selectedCountry ? "Search university..." : "Select country first"
//             }
//             styles={{
//               container: (base) => ({ ...base, width: "100%" }),
//               control: (base, state) => ({
//                 ...base,
//                 width: "100%",
//                 minHeight: "50px",
//                 padding: "0 8px",
//                 borderRadius: "0.75rem",
//                 borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
//                 boxShadow: state.isFocused
//                   ? "0 0 0 2px rgba(59,130,246,0.3)"
//                   : "none",
//                 "&:hover": { borderColor: "#3b82f6" },
//               }),
//               valueContainer: (base) => ({ ...base, padding: "0" }),
//               input: (base) => ({ ...base, margin: 0, padding: 0 }),
//             }}
//           />
//         </div>
//       </>
//     )}

//     {/* Other Button */}
//     <button
//       type="button"
//       className="h-[50px] px-4 bg-gray-200 rounded-xl hover:bg-gray-300 text-sm font-medium"
//       onClick={() =>
//         setChoice(choice === "select" ? "manual" : "select")
//       }
//     >
//       Other
//     </button>
//   </div>

//   {/* Manual Input */}
//   {choice === "manual" && (
//     <input
//       type="text"
//       name="name"
//       value={universityName}
//       onChange={(e) => setUniversityName(e.target.value)}
//       className="mt-2 w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//       placeholder="Enter university name"
//       required
//     />
//   )}
// </div>







//             {/* Contact Detail */}
//             <div className="mb-4">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Contact Detail <span className="text-red-500">*</span>
//               </label>
//               <input
//                 type="text"
//                 name="contactDetail"
//                 value={contactDetail}
//                 onChange={(e)=>setContactDetail(e.target.value)}
//                 className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//                 placeholder="Email or phone number"
//                 required
//               />
//             </div>
//         </div>
//         {/* Logo Upload Section */}
//         <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
//           <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">
//             University Logo
//           </h3>
          
//           <div className="md:col-span-2">
//             {logo ? (
//               <div className="relative border border-gray-300 rounded-xl p-4">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center space-x-4">
//                     <img 
//                       src={URL.createObjectURL(logo)} 
//                       alt="Logo preview" 
//                       className="w-16 h-16 object-cover rounded-lg"
//                     />
//                   </div>
//                 </div>
//                 <input
//                   type="file"
//                   name="logo"
//                   onChange={(e)=>setLogo(e.target.files[0])}
//                   accept="image/*"
                
//                   className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//                 />
//               </div>
//             ) : (
//               <div className="relative border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-blue-400 transition-colors duration-200 bg-gray-50">
//                 <input
//                   type="file"
//                   name="logo"
//                   onChange={(e) => setLogo(e.target.files[0])}
//                   accept="image/*"
//                   className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//                 />
//                 <div className="flex flex-col items-center">
//                   <svg className="w-12 h-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                   </svg>
//                   <p className="text-gray-600 font-medium">Click to upload logo</p>
//                   <p className="text-sm text-gray-500 mt-1">PNG, JPG, GIF up to 5MB</p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Address Section */}
//         <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
//           <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">
//             Address Information
//           </h3>
          
//           <div className="md:col-span-2">
//             <label className="block text-sm font-semibold text-gray-700 mb-2">
//               Full Address <span className="text-red-500">*</span>
//             </label>
//             <textarea
//               name="address"
//               value={address}
//               onChange={(e)=>setAddress(e.target.value)}
//               className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//               rows={3}
//               placeholder="Enter complete university address"
//               required
//             />
//           </div>
//         </div>

//         {/* Government Documents Section */}
//         <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
//           <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">
//             Legal Documents
//           </h3>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {/* Registration Number */}
//             <div className="md:col-span-2">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Registration Number
//               </label>
//               <input
//                 type="text"
//                 name="registrationNumber"
//                 value={registrationNumber}
//                 onChange={(e)=>setRegistrationNumber(e.target.value)}
//                 required
//                 className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//                 placeholder="Official registration number"
//               />
//             </div>

//             {/* Government Documents Upload */}
//             <div className="md:col-span-2">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Government Registered Documents 
//               </label>
              
//               {govDocuments ? (
//                 <div className="relative border border-gray-300 rounded-xl p-4">
//                   <div className="flex items-center justify-between">
//                     <div className="flex items-center space-x-4">
//                       <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                       </svg>
//                       <div>
//                         <p className="text-sm text-gray-600">{URL.createObjectURL(govDocuments)}</p>
//                       </div>
//                     </div>
//                   </div>
//                   <input
//                     type="file"
//                     name="govDocuments"
//                     onChange={(e)=>setGovDocuments(e.target.files[0])}
//                     accept=".pdf,.doc,.docx"
//                     className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//                   />
//                 </div>
//               ) : (
//                 <div className="relative border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-blue-400 transition-colors duration-200 bg-gray-50">
//                   <input
//                     type="file"
//                     name="govDocuments"
//                     onChange={(e)=>setGovDocuments(e.target.files[0])}
//                     accept=".pdf,.doc,.docx"
//                     className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//                   />
//                   <div className="flex flex-col items-center">
//                     <svg className="w-12 h-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                     </svg>
//                     <p className="text-gray-600 font-medium">Upload government documents</p>
//                     <p className="text-sm text-gray-500 mt-1">PDF, DOC, DOCX up to 10MB</p>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Submit Button */}
//         <div className="pt-2">
//           <div className="flex flex-col sm:flex-row gap-4 justify-between items-center">
//             <div className="flex gap-4 w-full sm:w-auto">
//               <button
//                 type="submit"
//                 className="px-8 py-3.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-indigo-700 transform hover:-translate-y-0.5 transition-all duration-200 shadow-md hover:shadow-lg w-full sm:w-auto"
//               >
//                {
//                loading ? "Creating...." : "Create University Profile"
//                }
//               </button>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
<div className="text-start max-w-[98%] mx-auto mt-10">
  <div className="bg-white rounded-2xl p-6 shadow-sm">
    {/* Header */}
    <div className="flex items-center gap-3 mb-8">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      </div>
      <div>
        <h2 className="text-xl font-semibold text-gray-900">University Registration</h2>
        <p className="text-sm text-gray-500 mt-0.5">Register your university profile</p>
      </div>
    </div>

    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Basic Information Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <h3 className="text-sm font-semibold text-gray-700">Basic Information</h3>
        </div>

        {/* University */}
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            University <span className="text-red-500">*</span>
          </label>
          
          <div className="flex gap-3 items-end">
            {choice !== "manual" && (
              <>
                {/* Country Select */}
                <div className="flex-1">
                  <Select
                    options={countryOptions}
                    isSearchable
                    value={selectedCountry}
                    onChange={(selected) => {
                      setSelectedCountry(selected);
                      setUniversityName("");
                    }}
                    placeholder="Select country..."
                    styles={{
                      container: (base) => ({ ...base, width: "100%" }),
                      control: (base, state) => ({
                        ...base,
                        width: "100%",
                        minHeight: "48px",
                        padding: "0 12px",
                        borderRadius: "12px",
                        borderColor: state.isFocused ? "#0f6abf" : "#d1d5db",
                        boxShadow: state.isFocused ? "0 0 0 2px rgba(15, 106, 191, 0.2)" : "none",
                        "&:hover": { borderColor: "#0f6abf" },
                      }),
                      valueContainer: (base) => ({ ...base, padding: "0" }),
                      input: (base) => ({ ...base, margin: 0, padding: 0 }),
                    }}
                  />
                </div>

                {/* University Select */}
                <div className="flex-1">
                  <Select
                    options={universities}
                    isSearchable
                    isDisabled={!selectedCountry}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.name}
                    value={universities.find((u) => u.name === universityName) || null}
                    onChange={(selected) => setUniversityName(selected?.name || "")}
                    placeholder={selectedCountry ? "Search university..." : "Select country first"}
                    styles={{
                      container: (base) => ({ ...base, width: "100%" }),
                      control: (base, state) => ({
                        ...base,
                        width: "100%",
                        minHeight: "48px",
                        padding: "0 12px",
                        borderRadius: "12px",
                        borderColor: state.isFocused ? "#0f6abf" : "#d1d5db",
                        boxShadow: state.isFocused ? "0 0 0 2px rgba(15, 106, 191, 0.2)" : "none",
                        "&:hover": { borderColor: "#0f6abf" },
                      }),
                      valueContainer: (base) => ({ ...base, padding: "0" }),
                      input: (base) => ({ ...base, margin: 0, padding: 0 }),
                    }}
                  />
                </div>
              </>
            )}

            <button
              type="button"
              className="h-[48px] px-4 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 text-sm font-medium transition-colors"
              onClick={() => setChoice(choice === "select" ? "manual" : "select")}
            >
              {choice === "select" ? "Other" : "Select from list"}
            </button>
          </div>

          {/* Manual Input */}
          {choice === "manual" && (
            <input
              type="text"
              name="name"
              value={universityName}
              onChange={(e) => setUniversityName(e.target.value)}
              className="w-full border border-gray-300 rounded-xl px-4 py-3 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              placeholder="Enter university name"
              required
            />
          )}
        </div>

        {/* Contact Detail */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Contact Detail <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="contactDetail"
            value={contactDetail}
            onChange={(e) => setContactDetail(e.target.value)}
            className="w-full border border-gray-300 rounded-xl px-4 py-3 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            placeholder="Email or phone number"
            required
          />
        </div>
      </div>

      {/* Logo Upload Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <h3 className="text-sm font-semibold text-gray-700">University Logo</h3>
        </div>

        {logo ? (
          <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] transition-colors">
            <div className="flex flex-col items-center">
              <img 
                src={URL.createObjectURL(logo)} 
                alt="Logo preview" 
                className="w-20 h-20 object-cover rounded-lg mb-3"
              />
              <p className="text-sm text-gray-600">Click to change logo</p>
              <p className="text-xs text-gray-500 mt-1">PNG, JPG, GIF up to 5MB</p>
            </div>
            <input
              type="file"
              name="logo"
              onChange={(e) => setLogo(e.target.files[0])}
              accept="image/*"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            />
          </div>
        ) : (
          <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-[#0f6abf] transition-colors">
            <input
              type="file"
              name="logo"
              onChange={(e) => setLogo(e.target.files[0])}
              accept="image/*"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            />
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-sm text-gray-600 font-medium">Click to upload logo</p>
              <p className="text-xs text-gray-500 mt-1">PNG, JPG, GIF up to 5MB</p>
            </div>
          </div>
        )}
      </div>

      {/* Address Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <h3 className="text-sm font-semibold text-gray-700">Address Information</h3>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Full Address <span className="text-red-500">*</span>
          </label>
          <textarea
            name="address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="w-full border border-gray-300 rounded-xl px-4 py-3 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-y min-h-[100px]"
            placeholder="Enter complete university address"
            required
          />
        </div>
      </div>

      {/* Government Documents Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <h3 className="text-sm font-semibold text-gray-700">Legal Documents</h3>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Registration Number
          </label>
          <input
            type="text"
            name="registrationNumber"
            value={registrationNumber}
            onChange={(e) => setRegistrationNumber(e.target.value)}
            required
            className="w-full border border-gray-300 rounded-xl px-4 py-3 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            placeholder="Official registration number"
          />
        </div>

        {/* Government Documents Upload */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Government Registered Documents
          </label>
          
          {govDocuments ? (
            <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] transition-colors">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <p className="text-sm text-gray-600">{URL.createObjectURL(govDocuments)}</p>
                <p className="text-sm text-gray-600">Click to change document</p>
                <p className="text-xs text-gray-500 mt-1">PDF, DOC, DOCX up to 10MB</p>
              </div>
              <input
                type="file"
                name="govDocuments"
                onChange={(e) => setGovDocuments(e.target.files[0])}
                accept=".pdf,.doc,.docx"
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              />
            </div>
          ) : (
            <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-[#0f6abf] transition-colors">
              <input
                type="file"
                name="govDocuments"
                onChange={(e) => setGovDocuments(e.target.files[0])}
                accept=".pdf,.doc,.docx"
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              />
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <p className="text-sm text-gray-600 font-medium">Upload government documents</p>
                <p className="text-xs text-gray-500 mt-1">PDF, DOC, DOCX up to 10MB</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Submit Button */}
      <div className="pt-4 border-t border-gray-100">
        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              Creating University Profile...
            </>
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
              </svg>
              Create University Profile
            </>
          )}
        </button>
      </div>
    </form>
  </div>
</div>
  );
};

export default UniversityForm;